import { Box, Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { Button, FormTextField } from "@covertree/ui";

import { QuestionModalProps } from "../underwritingQuestions";
import { UnderwritingQuestionsForm } from "../../../validatorsAndTypes/underwritingQuestions";

export function InsuranceTroubleForm({ closeModal }: QuestionModalProps) {
  const { formState, control } = useFormContext<UnderwritingQuestionsForm>();

  return (
    <Stack spacing={4}>
      <Box>
        <FormTextField
          id="insurance-trouble-reason"
          name="reasonCancellationRenew"
          label="What was the reason for the prior non-renewal or cancel?"
          dataTestId="insurance-trouble-reason"
          placeholder="Text here"
          control={control}
          multiline
          rows={4}
        />
      </Box>
      <Box>
        <Button
          type="button"
          onClick={closeModal}
          disabled={!formState.isValid}>
          Save
        </Button>
      </Box>
    </Stack>
  );
}
